import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { RegistrosService } from './../../../../services/API/registros/registros.service';
import { Router } from '@angular/router';
import { AuthService } from './../../../../services/API/auth/auth.service';
import { MatSort, Sort } from '@angular/material/sort';
import { NotificationServiceService } from './../../../../services/notification-service/notification-service.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, finalize } from 'rxjs/operators';

@Component({
    selector: 'app-clasificar-registros',
    templateUrl: './clasificar-registros.component.html',
    styleUrls: ['./clasificar-registros.component.css'],
    standalone: false
})
export class ClasificarRegistrosComponent implements OnInit, OnDestroy {

  showProgressBar: boolean = true;
  displayedColumns = ['albaran', 'fechaFin', 'clasificado'];
  pages = [20, 50, 100];
  filter: string = '';
  dataSource = new MatTableDataSource<any>([]);
  totalRecords = 0;
  pageSize = 25;
  pageIndex = 0;
  sortColumn = 'fechaFin';
  sortDirection: 'asc' | 'desc' = 'desc';

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  clasificado: string = 'false';

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  constructor(
    public authService: AuthService,
    private registrosService: RegistrosService,
    private notificationService: NotificationServiceService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.userRolCheck('permiso_clasificar');
    this.paginator._intl.itemsPerPageLabel = 'Registros por página:';
    this.searchSubscription = this.searchSubject.pipe(debounceTime(400)).subscribe(() => {
      this.pageIndex = 0;
      this.loadRegistros();
    });
    this.loadRegistros();
  }

  ngOnDestroy(): void {
    this.searchSubscription?.unsubscribe();
  }

  userRolCheck(permission: string) {
    if (!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  loadRegistros() {
    this.showProgressBar = true;
    this.registrosService.getRegistrosPaginated({
      clasificado: this.clasificado,
      page: this.pageIndex + 1,
      pageSize: this.pageSize,
      search: this.filter,
      recordType: 'pesaje',
      sort: this.sortColumn,
      direction: this.sortDirection,
    }).pipe(
      finalize(() => {
        this.showProgressBar = false;
      })
    ).subscribe({
      next: (result) => {
        const parsed = this.parseRegistrosResponse(result);
        this.dataSource.data = parsed.data;
        this.totalRecords = parsed.total;
      },
      error: () => {
        this.dataSource.data = [];
        this.totalRecords = 0;
        this.notificationService.openSnackBar('No se pudieron cargar los registros');
      }
    });
  }

  private parseRegistrosResponse(result: any): { data: any[]; total: number } {
    if (Array.isArray(result)) {
      return { data: result, total: result.length };
    }
    return {
      data: result?.data ?? [],
      total: result?.total ?? 0,
    };
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadRegistros();
  }

  onSortChange(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      return;
    }
    if (sort.active === this.sortColumn && sort.direction === this.sortDirection) {
      return;
    }
    this.sortColumn = sort.active;
    this.sortDirection = sort.direction;
    this.pageIndex = 0;
    this.loadRegistros();
  }

  applyFilter(event: Event) {
    this.filter = (event.target as HTMLInputElement).value;
    this.searchSubject.next(this.filter);
  }

  onClasificadoChange() {
    this.pageIndex = 0;
    this.loadRegistros();
  }

  reload() {
    this.loadRegistros();
  }

  verRegistro(albaran: string) {
    this.router.navigateByUrl('/dashboard/clasificar-registro/' + albaran);
  }

}
